<template>
  <div class="content-page">
    <div class="main-page">
      <div class="title-page"></div>
      <div class="backgroundBox">
         <el-alert
          type="warning"
          v-if="isHint"
          :closable="false"
          title="为做好新《中华人民共和国行政复议法》的实施准备工作，“上海市行政复议网上申请平台”、“上海复议”小程序以及随申办“上海复议”模块将于2023年12月29日 17:30--2023年12月31日24：00进行系统升级改造，期间网上申请平台、“上海复议”小程序和随申办“上海复议”模块将关闭入口。系统改造期间如需申请行政复议，可通过邮寄方式向各级行政复议机关提交申请。"
          show-icon>
        </el-alert>
        <!-- 登录/退出区域 -->
        <div class="login_or_loginOut" :class="{ 'has-hint': isHint }">
          <div  v-if="isLogin" class="user-name">
            <span>
              您好，{{userName}}
              <img class="true-name-icon" src="@/assets/images/true_name_icon.png" alt="" srcset="">
            </span>
            <el-button type="primary" v-if="isLogin" class="logout_btn" @click="logout">退出</el-button>
          </div>
          <div v-else  class="user-name">
            <span></span>
            <el-button type="primary" class="login_btn" @click="goToLogin">登录</el-button>
          </div>
        </div>
        <!-- 版本更新提示 -->
        <div v-if="showVersionUpdateTip && versionUpdateTipText" class="version-update-tip">
          <img class="version-img" src="@/assets/images/notice-icon.png" alt=""/>
          <div class="version-text">{{ versionUpdateTipText }}</div>
        </div>
        <div class="main-contentBox">
          <div class="co-contentBox">
            <div class="co-rightBox">
              <div class="star-title">
                <span class="star"></span>网上申请内容介绍
              </div>
              <div class="co-rightText">
                “行政复议网上申请”是为方便公民、法人和其他组织（以下统称申请人）行使复议申请权，开辟的行政复议申请渠道。申请人可通过本网站提交行政复议申请及相关材料。经初步审查后，如申请材料齐全、真实，行政复议机构将根据行政复议法的相关规定依法作出处理。 </div>
              <div class="btnLists">
                <el-row :gutter="50">
                  <el-col :lg="8" :md="8" align="center"><el-button type="primary" style="width: 135px;font-size:16px;height:50px" @click="go('apply','/matterTip')">我要申请</el-button></el-col>
                  <el-col :lg="8" :md="8" align="center"><el-button type="primary" style="width: 135px;font-size:16px;height:50px" @click="go('revokeApply','/selectType')">我要撤回</el-button></el-col>
                  <el-col :lg="8" :md="8" align="center"><el-button type="primary" style="width: 135px;font-size:16px;height:50px" @click="go('search','/selectType')">我的案件</el-button></el-col>
                  
                </el-row>
              </div>
            </div>
<!--            <div class="co-leftBox">-->
<!--              <div class="star-title">-->
<!--                <span class="star"></span>网上申请查询-->
<!--              </div>-->
<!--              <el-form :model="searchForm" :rules="rules" ref="searchForm" label-width="120px"-->
<!--                       class="demo-ruleForm search-items ">-->
<!--                <el-form-item label="申请编号" prop="number" class=" col1-80">-->
<!--                  <el-input placeholder="请输入申请编号" v-model.trim="searchForm.number" maxlength="20"></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="密码" prop="password" class=" col1-80">-->
<!--                  <el-input type="password" placeholder="请输入密码" v-model.trim="searchForm.password"-->
<!--                            autocomplete="new-password" maxlength="10"></el-input>-->
<!--                </el-form-item>-->
<!--              </el-form>-->
<!--              <div class="btnLists">-->
<!--                <div v-no-more-div class="primary-btn" @click="submitForm('searchForm')"> 查询 </div>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </div>
    <!-- 人脸识别弹窗 -->
    <faceIdTip ref="faceIdTip" @nextTep="handleFaceIdSuccess" />
  </div>
</template>

<script>
import Api from '@api/api'
import faceIdTip from '@/components/face/faceIdTip.vue'
import { mapState, mapActions } from 'vuex'

export default {
  components: {
    faceIdTip
  },
  data () {
    return {
      isHint: window.g.hint,
      searchForm: {
        number: null,
        password: null
      },
      rules: {
        number: [
          { required: true, message: '请输入申请编号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      },
      // 版本更新提示相关
      showVersionUpdateTip: false,
      versionUpdateTipText: ''
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin,
      userName: state => state.user.userName
    })
  },
  mounted () {
    // 初始化登录状态
    this.initLoginStatus()
    // 获取版本更新提示
    this.getVersionUpdateTip()
  },
  activated () {
    // 如果使用了 keep-alive，页面激活时重新初始化登录状态
    this.initLoginStatus()
  },
  watch: {
    // 监听路由变化，从登录页返回时更新登录状态
    '$route' (to, from) {
      if (from.path === '/searchLogin' || from.path === '/login') {
        this.initLoginStatus()
      }
    }
  },
  methods: {
    ...mapActions(['initLoginStatus', 'clearLoginStatus']),
    // 跳转到登录页面（打开人脸识别弹窗）
    goToLogin () {
      // 检查是否有申请人信息，如果没有则跳转到登录页面
      this.$router.push('/login')
    },
    // 人脸识别成功后的处理
    handleFaceIdSuccess () {
      // 人脸识别成功后，更新登录状态
      this.initLoginStatus()
      this.$message.success('登录成功')
    },
    // 退出登录
    logout () {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 清除登录相关数据
        localStorage.removeItem('applicantInfo')
        localStorage.removeItem('applicantCategory')
        localStorage.removeItem('sessionId')
        localStorage.removeItem('oprate')
        localStorage.removeItem('loginIdentificationCard')
        localStorage.removeItem('loginName')
        localStorage.removeItem('isLogin')
        localStorage.removeItem('isRegistered')
        // 清除 Vuex 中的登录状态
        this.clearLoginStatus()
        this.$message({
          type: 'success',
          message: '已退出登录'
        })
      }).catch(() => {
        // 取消退出
      })
    },
    go (oprate, url) {
      // 检查登录状态
      if (!this.isLogin) {
        this.$message.warning('请先登录')
        return
      }
      localStorage.setItem('oprate', oprate)
      this.$router.push(url)
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api.detail(this.searchForm).then((res) => {
            if (res.data.code === '0') {
              this.$message({
                message: '查询成功',
                type: 'success',
                duration: 500,
                onClose: () => {
                  this.$cookie.set('LoginPass', this.searchForm.password)
                  this.$router.push({
                    name: 'DetailCase',
                    query: {
                      number: this.searchForm.number
                    }
                  })
                }
              })
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 获取版本更新提示
    getVersionUpdateTip () {
      Api.getVersionUpdateTip().then(res => {
        console.log('版本更新提示接口返回：', res);
        let tipText = '';
        if (res.data.code === '0' && res?.data?.data) {
          tipText = res.data.data.title || null;
        }
        
        // 如果获取到内容则显示，否则不显示提示
        if (tipText) {
          this.showVersionUpdateTip = true;
          this.versionUpdateTipText = tipText;
        } else {
          this.showVersionUpdateTip = false;
          this.versionUpdateTipText = '';
        }
      }).catch(err => {
        console.log('获取版本更新提示失败：', err);
        // 接口调用失败，不显示提示
        this.showVersionUpdateTip = false;
        this.versionUpdateTipText = '';
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.main-contentBox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10%;
  // padding-right: 10%;
  margin-bottom: 11%;
  margin-right: 12%;
  margin-top: 10%;
  //  padding: 140px 140px 160px;
  //  padding: 10% 10% 11%;

  .star-title {
    margin-bottom: 4%;
  }

  .co-contentBox {
    display: flex;
    align-items: baseline;
    justify-content: space-around;
    background: rgba(255, 255, 255, 0.05);
    box-shadow: 2px 6px 10px 0px rgba(128, 126, 189, 0.24);
    border-radius: 8px;
    backdrop-filter: blur(20px);
    padding: 2% 0;

    .co-leftBox {
      margin: 0 2%;
    }

    .co-rightBox {
      margin: 0 2%;
      width: 100%;

      .co-rightText {
        word-break: break-all;
        width: 90%;
        margin: 0 auto;
        line-height: 26px;
      }
    }

    .btnLists {
      margin: 0 auto;
      width: 80%;
      .el-col {
        margin-top: 30px;
      }
    }
  }



  @media screen and (max-width: 1000px) {
    .co-contentBox {
      display: flex;
      width: 100%;
      padding: 10%;
      backdrop-filter: none;
      flex-direction:column;
      position:relative;
      // background-color: pink;
    }
    .co-leftBox {
    //  position: absolute;
    //  top: 0;
    //  left: 0;
    width: 100% !important;

     .el-input{
      width: 140px !important;
     }
     .primary-btn{
      margin-top: -10px;
     }
    }

    .co-rightBox {
    //  margin-top: 220px !important;
     width: 100% !important;
     .border-btn{
      margin-top: 10px !important;
      margin-bottom: 20px !important;
     }
    }

    .primary-btn {
      width: 120px !important;
    }

    .gary-btn {
      width: 120px !important;
    }

    .border-btn {
      width: 120px !important;
    }

    .col1-80 {
      width: 100% !important;

    }
    .co-rightBox{
      margin-right: 10px !important;
    }
  }
}
::v-deep .el-alert__title {
    font-size: 14px!important;
    line-height: 25px;
  }
  .backgroundBox {
    position: relative;
  }

.login_or_loginOut {
  position: absolute;
  right: 0;
  width: 100%;
  
  &.has-hint {
    top: 100px;
  }
  
  &:not(.has-hint) {
    top: 20px;
  }
  .user-name {
    font-size: 16px;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    .true-name-icon {
      width: 22px;
      height: 22px;
      vertical-align: middle;
    }
  }
  .login_btn,
  .logout_btn {
    padding: 8px 20px;
    font-size: 14px;
  }
}

.version-update-tip {
  top: 65px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px 20px;
  margin-left: 10%;
  margin-right: 12%;
  max-width: 1200px;
  font-weight: 700;
  position: relative;
  
  .version-img {
    width: 40px;
    height: 40px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  
  .version-text {
    flex: 1;
    color: #333;
    font-size: 14px;
    line-height: 22px;
  }
}
@media screen and (max-width: 1000px) {
  .login_or_loginOut {
    padding: 15px 5%;
    justify-content: center;

    .user-info {
      flex-direction: column;
      gap: 10px;
      width: 100%;
      align-items: center;

      .user-name {
        font-size: 14px;
      }
    }

    .login_btn,
    .logout_btn {
      width: 100px;
      font-size: 12px;
    }
  }
}
</style>
